import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faEllipsisV,
  faEye,
  faEyeSlash,
  faLanguage,
  faPlus,
  faRocket,
  faTachometerAlt,
  faTimes,
  faTrash,
  faUser,
  faUserFriends,
} from "@fortawesome/free-solid-svg-icons";

const icons = {
  applications: faRocket,
  caretDown: faAngleDown,
  caretLeft: faAngleLeft,
  caretUp: faAngleUp,
  close: faTimes,
  dashboard: faTachometerAlt,
  delete: faTrash,
  hide: faEyeSlash,
  language: faLanguage,
  moreOptionsMenu: faEllipsisV,
  operations: faUserFriends,
  plus: faPlus,
  profile: faUser,
  show: faEye,
} as const;

type FontAwesomeIconProps = React.ComponentProps<typeof FontAwesomeIcon>;

type Props = Omit<FontAwesomeIconProps, "icon"> & {
  icon: keyof typeof icons;
};

const Icon = ({ icon, ...restProps }: Props) => {
  return <FontAwesomeIcon {...restProps} icon={icons[icon]} />;
};

export default Icon;
